export function mVToVolt(
  value: number | string,
  fractionDigit: number = 1,
): string {
  return ((typeof value === 'string' ? parseInt(value, 10) : value) / 1000)
    .toFixed(fractionDigit)
    .concat(' V');
}

export function convertTauxAccroissement(value: number) {
  return (10000 / value).toFixed(1) + ' mV/pH';
}
